import { render, staticRenderFns } from "./deputyAdmin.vue?vue&type=template&id=2fbb2d94&scoped=true&"
import script from "./deputyAdmin.vue?vue&type=script&lang=js&"
export * from "./deputyAdmin.vue?vue&type=script&lang=js&"
import style0 from "./deputyAdmin.vue?vue&type=style&index=0&id=2fbb2d94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb2d94",
  null
  
)

export default component.exports